import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { HourglassEmpty } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

function WaitingForParticipants() {
  const { t } = useTranslation('shared');
  return (
    <Card sx={{
      backgroundColor: 'rgba(33, 150, 243, 0.1)',
      border: '1px solid #2196f3',
      textAlign: 'center',
      py: 4
    }}>
      <CardContent>
        <HourglassEmpty sx={{ fontSize: 48, color: '#2196f3', mb: 2 }} />
        <Typography variant="h6" sx={{ color: '#2196f3', fontWeight: 'bold' }}>
          {t('waitingForParticipants.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={1}>
          {t('waitingForParticipants.message')}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default WaitingForParticipants;
